// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import store from './store/store'
// import 'lib-flexible/flexible'
import '@/utils/flexible.js'
import '@/utils/vueFilter.js'
import globalUrl from '@/utils/global.js'

import axios from 'axios'
// let PDFJS = require('pdfjs-dist').PDFJS
// PDFJS.workerSrc = require('pdfjs-dist/build/pdf.worker.min')
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.config.keyCodes = {
  'Caps_Locke': 20
}
Vue.use(Element)
Vue.prototype.$globalUrl = globalUrl
Vue.prototype.$axios = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js